<script setup>
import { router } from '@inertiajs/vue3';
import InputField from '@js/components/fields/InputField.vue';
import SwitchField from '@js/components/fields/SwitchField.vue';
import FormColumn from '@js/components/forms/FormColumn.vue';
import FormContent from '@js/components/forms/FormContent.vue';
import FormFooter from '@js/components/forms/FormFooter.vue';
import FormGrid from '@js/components/forms/FormGrid.vue';
import FormRoot from '@js/components/forms/FormRoot.vue';
import { useRoute } from '@js/utils/route';
import { toastError, toastSaved } from '@js/utils/toast';
import { reactive, ref } from 'vue';
import { boolean, object, string } from 'yup';

const { tenant, externalService } = defineProps({
    tenant: {
        required: true,
        type: Object,
    },
    externalService: {
        required: true,
        type: Object,
    },
});

const { route } = useRoute();

const isSubmitting = ref(false);

const form = reactive({
    active: externalService.active,
    pageId: externalService.data.pageId,
});

const validationSchema = object({
    active: boolean().required('Ce champ est requis.'),
    pageId: string().nullable(),
});

function submit() {
    isSubmitting.value = true;

    axios
        .post(
            route(
                'front.projectManagement.customer.externalServices.postFacebook',
                {
                    tenant: tenant.id,
                },
            ),
            {
                active: form.active,
                pageId: form.pageId,
            },
        )
        .then(() => {
            toastSaved();

            router.visit(
                route(
                    'front.projectManagement.customer.externalServices.facebook',
                    {
                        tenant: tenant.id,
                    },
                ),
            );
        })
        .finally(() => {
            isSubmitting.value = false;
        })
        .catch((error) => {
            toastError(error);

            router.visit(
                route('front.projectManagement.customer.externalServices'),
            );
        });
}
</script>

<template>
    <FormRoot
        v-slot="{ errors }"
        :validation-schema="validationSchema"
        :submit="submit"
    >
        <FormColumn>
            <FormContent>
                <SwitchField
                    v-model="form.active"
                    label="Actif"
                    field-name="active"
                    field-id="active"
                />
            </FormContent>

            <FormContent>
                <FormGrid>
                    <InputField
                        v-model="form.pageId"
                        label="ID de la page"
                        field-name="pageId"
                        field-id="pageId"
                        required
                    />
                </FormGrid>
            </FormContent>
        </FormColumn>

        <FormFooter :is-submitting="isSubmitting" :errors="errors" />
    </FormRoot>
</template>
